import { lbApiBeta } from '@/utils/axiosConfig';

/**
 * What the CompleteListingModal asks for, on the first residence only:
 * pictures (2+ photos, or a floorplan) and a description. Floorplans and
 * photos stay separate everywhere else; here a floorplan covers the picture
 * step, for simplicity.
 *
 * `firstResidenceNeedsWork` is a client-side pre-check against the store so
 * the trigger can stay idle without a network round-trip;
 * `summaryNeedsWork` re-checks against /api/my-proposition/completion, the
 * same data the modal renders, right before it opens.
 */
const MODAL_STEP_KEYS = ['images', 'description'];
const MIN_IMAGES_FOR_COMPLETION = 2;
// bilder_typer id for floorplans.
const FLOORPLAN_IMAGE_TYPE_ID = 11;

export function firstResidenceNeedsWork(proposition) {
  const residence = proposition?.residences?.[0];
  if (!residence) return false;
  const images = residence.images || [];
  const hasPictures =
    images.length >= MIN_IMAGES_FOR_COMPLETION ||
    images.some(image => image.typeId === FLOORPLAN_IMAGE_TYPE_ID);
  return !hasPictures || !residence.description;
}

// The steps the modal lists for a completion summary.
export function modalStepKeys(summary) {
  const floorplan = summary?.residences?.[0]?.floorplan;
  return floorplan?.current > 0
    ? MODAL_STEP_KEYS.filter(key => key !== 'images')
    : MODAL_STEP_KEYS;
}

export function summaryNeedsWork(summary) {
  const residence = summary?.residences?.[0];
  if (!residence) return false;
  return modalStepKeys(summary).some(key => {
    const entry = residence[key];
    return !!entry && (entry.current ?? 0) < (entry.max ?? 0);
  });
}

export async function fetchCompletionSummary(propositionId) {
  try {
    const { data } = await lbApiBeta.get(
      `/api/my-proposition/completion/${propositionId}`
    );
    return data;
  } catch (e) {
    console.error('Failed to fetch listing summary:', e);
    return null;
  }
}
